import { Component } from "@angular/core";
import {
  IonicPage,
  ToastController,
  PopoverController,
  Popover,
  ActionSheetController,
  LoadingController,
} from "ionic-angular";
import { pouchdb2 } from "../../services/pouchdb/pouchdb.service";
import { APIOnLine } from "../../services/api/api.services";
import { Proxy } from "../../services/proxy/proxy.service";
import { PaginaBasica } from "../../models/PaginaBase";
import { NuevoMenuDerechoComponent } from "../../components/nuevo-menu-derecho/nuevo-menu-derecho";

@IonicPage()
@Component({
  selector: "page-derechos",
  templateUrl: "derechos.html",
})
export class DerechosPage extends PaginaBasica {
  // #region Propiedades del controlador
  public designacion: Proxy.PrDesignaciones;
  public idEquipo: number;
  // #endregion

  constructor(
    public actionSheetCtrl: ActionSheetController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DBService2: pouchdb2.DBService2,
    public loadingCtrl: LoadingController,
    public Persistentes: APIOnLine.Persistentes,
    public popOverCtrl: PopoverController,
    public toastCtrl: ToastController
  ) {
    super(loadingCtrl, toastCtrl);
  }

  ionViewDidLoad() {
    this.designacion = this.Persistentes.GetDesignacion();
    this.idEquipo = this.Persistentes.GetIdEquipo();
  }

  //#region Métodos del controlador

  public AbrirMenuSecundario(event: any): void {
    let popover: Popover = this.popOverCtrl.create(NuevoMenuDerechoComponent);

    popover.present({
      ev: event,
    });
  }

  public GuardarDerechos(): void {
    this.designacion.Derechos.Guardar(this.idEquipo)
      .then((resultado: Proxy.PrActasDerechos) => {
        this.Mensaje(
          "Se han guardado correctamente el pago de los Derechos Arbitrales.",
          0
        );
      })
      .catch((error) => {
        this.designacion.OtrosDatos.urlApi = this.designacion.urlApi;
        this.designacion.OtrosDatos.urlNombre = this.designacion.urlNombre;

        // Se guarda en las incidencias no modificables, que no ha abonado los derechos arbitrales
        this.designacion.OtrosDatos.incidenciasNoModificables +=
          "<p>El equipo <b>" +
          (this.designacion.EquipoLocal(this.idEquipo)
            ? this.designacion.local
            : this.designacion.visitante) +
          " no abona los derechos arbitrales.</p>";
        this.designacion.OtrosDatos.Guardar();

        this.Mensaje(error, 0);
      });
  }

  //#endregion
}



// WEBPACK FOOTER //
// ./src/pages/derechos/derechos.ts